import { Entypo } from "@expo/vector-icons";
import React, { useCallback, useContext, useState } from "react";
import { StyleSheet, TouchableWithoutFeedback, View } from "react-native";
import { useTheme } from "react-native-elements";
import Divider from "./Divider";
import { PlayerContextFreezer } from "./PlayerContextFreezer";
import { Text } from "./Text";
import { VisibilityContext } from "./VisibilityContext";

type CategoryContainerProps = {
  title: string;
  titleStyle?: any;
  containerStyle?: any;
  contentContainerStyle?: any;
  children: any;
  disableExpand?: boolean;
};

export function CategoryHeader(
  props: Omit<CategoryContainerProps, "children">,
) {
  return (
    <View style={[styles.category, props.containerStyle]}>
      <Text style={[styles.categoryTitle, props.titleStyle]} h4>
        {props.title}
      </Text>
      <Divider style={styles.categoryDivider} />
    </View>
  );
}

export default function CategoryContainer(props: CategoryContainerProps) {
  const theme = useTheme();
  const [isExpanded, setExpanded] = useState(true);

  const visible = useContext(VisibilityContext);

  const setExpandedCallback = useCallback(() => {
    setExpanded(!isExpanded);
  }, [setExpanded, isExpanded]);

  let categoryHeader;
  if (props.disableExpand) {
    categoryHeader = (
      <View style={styles.categoryHeader}>
        <Text style={[styles.categoryTitle, props.titleStyle]} h4>
          {props.title}
        </Text>
      </View>
    );
  } else {
    categoryHeader = (
      <TouchableWithoutFeedback
        onPress={setExpandedCallback}
        accessibilityRole="header"
        accessibilityLabel={
          props.title +
          (isExpanded
            ? ", Expanded - Press to Collapse"
            : ", Collapsed - Press to Expand")
        }
      >
        <View style={styles.categoryHeaderExpand}>
          <Text style={[styles.categoryTitle, props.titleStyle]} h4>
            {props.title}
          </Text>
          <Entypo
            name={isExpanded ? "chevron-down" : "chevron-right"}
            size={24}
            color={theme.theme.colors.black}
          />
        </View>
      </TouchableWithoutFeedback>
    );
  }

  return (
    <View style={[styles.category, props.containerStyle]}>
      {categoryHeader}
      <Divider style={styles.categoryDivider} />
      <PlayerContextFreezer isVisible={isExpanded && visible}>
        <View
          style={[
            { display: isExpanded ? "flex" : "none" },
            props.contentContainerStyle,
          ]}
        >
          {props.children}
        </View>
      </PlayerContextFreezer>
    </View>
  );
}

const styles = StyleSheet.create({
  category: { paddingTop: 16 },
  categoryTitle: { fontWeight: "bold" },
  categoryDivider: { height: StyleSheet.hairlineWidth * 2 },
  categoryHeader: {
    height: 26,
  },
  categoryHeaderExpand: {
    height: 26,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    cursor: "pointer",
  },
});
